module.exports = __webpack_public_path__ + "static/media/reception5.6d237c1f.jpg";